import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal-cleanup"
// Attach to body to clean up modals before Turbo cache
export default class extends Controller {
  connect() {
    this.boundCleanup = this.cleanup.bind(this)
    document.addEventListener('turbo:before-cache', this.boundCleanup)
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.boundCleanup)
  }

  cleanup() {
    if (document.body.classList.contains('modal-open')) {
      const modals = document.querySelectorAll('.modal.show')
      modals.forEach(modalEl => {
        const instance = bootstrap.Modal.getInstance(modalEl)
        if (instance) instance.hide()
      })
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
      document.body.classList.remove('modal-open')
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('padding-right')
    }
  }
}
